
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.905 13.058H2.867v.327l.004.085a.865.865 0 00.861.78h5.34a2.364 2.364 0 01-.167-.865v-.327zm-1.344-2.9V9.83h-.328a.75.75 0 010-1.5H8.85a.327.327 0 000-.654H7.772a1.827 1.827 0 01-.211-3.64v-.34a.75.75 0 011.5 0v.326h.327l.076.004a.75.75 0 010 1.493l-.076.003H7.772a.328.328 0 00-.231.558.328.328 0 00.231.096H8.85a1.827 1.827 0 01.21 3.64v.341a.75.75 0 01-1.5 0zm2.85 3.312a.864.864 0 00.86.78l.085-.004a.866.866 0 00.776-.776l.005-.085V1.75H4.482v9.808h5.173a.75.75 0 01.75.75v1.077l.005.085zm3.214.148a2.367 2.367 0 01-2.12 2.12l-.234.012H3.732a2.366 2.366 0 01-2.353-2.132l-.012-.233v-1.077a.75.75 0 01.75-.75h.865V1l.004-.077A.75.75 0 013.732.25h9.155a.75.75 0 01.75.75v12.385l-.012.233z","fill":"#4A4A4A"}})])
          )
        }
      }
    